import {
  EpkModuleApiService,
  getFilteredData,
} from '~packages/epk-front-shared/api-client';
import type { Filters, Params } from '~packages/epk-front-shared/api-client';
import { Mode, RequestMethod } from '~packages/json-api/client';

import getConstants from '@/shared/constants';

const { isModeDevelopment } = getConstants();

const constructorParams = {
  className: 'EpksApiService',
  mode: isModeDevelopment ? Mode.Production : Mode.Production,
  needInit: isModeDevelopment,
};

export default class EpksApiService extends EpkModuleApiService {
  constructor() {
    super(constructorParams);
  }

  async getAllBooks() {
    return await super.fetchAll();
  }

  async getBookById(id) {
    return await super.fetch(id);
  }

  async addBookById(params) {
    return await super.add(params);
  }

  async getAllOktmos(path) {
    return await super.fetch(path);
  }

  async getFilteredData(filters: Filters, params: Params) {
    return await getFilteredData(this, filters, params);
  }

  async uploadFiles(file: FormData) {
    return await this._sendRequest(
      this.pathUpdate + 'import',
      null,
      { method: 'POST', body: file },
      { method: 'uploadFiles' }
    );
  }

  async deleteByCode(code: string) {
    return await this._sendRequest(
      `/${code}`,
      undefined,
      { method: RequestMethod.DELETE },
      { method: 'delete' }
    );
  }

  async getRelated(code: string) {
    return await this._sendRequest(
      `/${code}/related`,
      undefined,
      { method: RequestMethod.GET },
      { method: 'related' }
    );
  }
}
